import React from "react"
import styled from "styled-components"
import { MELOGY_WHITE } from "../../../style/colors"
import { FONT_SIZE_2XS } from "../../../style/fontSettings"

const Text = styled.div`
    width: min(calc(80vw - 32px - 16px), calc(480px - 32px - 16px));
    font-size: ${FONT_SIZE_2XS};
    letter-spacing: 0.2px;
    color: ${MELOGY_WHITE};
    user-select: none;
`

const EmptySpace = styled.div`
    width: min(calc(80vw - 32px - 16px), calc(480px - 32px - 16px));
    height: 16px;
`

const AboutPopoverContent = () => {
    const videoRef = React.useRef(null)

    const togglePlay = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                videoRef.current.play()
            } else {
                videoRef.current.pause()
            }
        }
    }

    return (
        <>
            <Text>
                I'm Mikko Virtala, a programmer and composer from Helsinki.
            </Text>
            <EmptySpace />
            <Text>
                Melogy is a music generation tool. It uses a combination of user
                input, algorithmic randomization, and music theory to create
                unique compositions.
            </Text>
            <EmptySpace />
            <Text>
                The goal of Melogy is to simplify the exploration and creation
                of new musical styles. It's a practical tool for both music
                enthusiasts and creators, offering an intuitive platform for
                musical experimentation.
            </Text>
            <EmptySpace />
            <Text>
                All music generated and downloaded through Melogy is fully yours
                to use and adapt in any way you see fit.
            </Text>
        </>
    )
}

export default AboutPopoverContent
